import { Navigate, useLocation } from "react-router-dom";
import { applyAuthParams, hasToken } from "./utils/authToken";

const allowedWithToken = [ // have to add these routes as during forgot passwrd we have to save token in localstorage as need tht in change password page but if token is there automatically redirected to protected route, to change that behaviour using this
  "/auditor/auth/forgot_password",
  "/auditor/auth/change_password",
   "/auditor/auth/signup",
];


const PublicRoute = ({ children }) => {
  const location = useLocation();
  const params = applyAuthParams(location.search);
  const allowParam = params.get("allow"); // from changepassword page getting this param but it won't be shown in url as in Login page onmount deleting it

  // return hasToken() ? <Navigate to="/auditor/audit" replace /> : children;
  if (
  hasToken() &&
  !allowedWithToken.some(path => location.pathname.startsWith(path)) && // so that with token also it doesn't redirect to private route
  !(location.pathname === "/auditor/auth/login" && allowParam === "1") // when coming from change password page to login page
) {
  return <Navigate to="/auditor/audit" replace />;
}
return children;
};

export default PublicRoute;
